import { Component, Input, OnDestroy, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Modal } from 'src/app/shared/modals/modal';
import { ModalHeaderComponent } from 'src/app/shared/modals/components/modal-header/modal-header.component';
import { ButtonModule } from 'primeng/button';
import { TabViewModule } from 'primeng/tabview';
import { SessionAttendanceComponent } from 'src/app/shared/components/session-attendance/session-attendance.component';
import { ISessionCardData, ISessionCardState, SessionCardStoreService } from 'src/app/shared/services/store/session-card-store.service';
import { SkeletonModule } from 'primeng/skeleton';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ShopItemHelperService } from 'src/app/shared/services/helpers/shop-item-helper.service';
import { NgbModal, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { FormArray, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { SessionFormat } from 'src/app/shared/enums/session-group/session-formats.enum';
import { BehaviorSubject, Subscription, take, merge, filter, map } from 'rxjs';
import { dateToTimeString, timeStringToDate } from 'src/app/shared/components/time-input/time-input.component';
import { InputTextModule } from 'primeng/inputtext';
import { SelectButtonModule } from 'primeng/selectbutton';
import { CalendarModule } from 'primeng/calendar';
import { IOrgLocationsState, OrgLocationsStoreService } from 'src/app/shared/services/store/org-locations-store.service';
import { Dropdown, DropdownChangeEvent, DropdownModule } from 'primeng/dropdown';
import { ModalService } from 'src/app/shared/services/modal.service';
import { LocationModalComponent } from 'src/app/shared/modals/location-modal/location-modal.component';
import { Operation } from 'src/app/shared/enums/utils/operations.enum';
import { SessionLecturerType } from 'src/app/shared/enums/session-group/session-lecturer-types.enum';
import { IHourRateFG, getHourRateFG } from 'src/app/shared/components/hour-rate-fg/hour-rate-fg.component';
import { SessionLecturerState } from 'src/app/shared/enums/session-group/session-lecturer-states.enum';
import { LecturerAvatarNameComponent } from 'src/app/shared/components/lecturer-avatar-name/lecturer-avatar-name.component';
import { ISelectButtonColoredItem, SelectButtonColoredComponent } from 'src/app/shared/components/select-button-colored/select-button-colored.component';
import { Menu, MenuModule } from 'primeng/menu';
import { ILecturersState, LecturersStoreService } from 'src/app/shared/services/store/lecturers-store.service';
import { ILecturer } from 'src/app/shared/models/user/lecturer/lecturer.model';
import { Color } from 'src/app/shared/enums/utils/colors';
import { UserNameOrEmailPipe } from 'src/app/shared/pipes/user-name-or-email.pipe';
import { MenuItem, SelectItem } from 'primeng/api';
import { ISessionLecturer } from 'src/app/shared/models/session-group/session-lecturer.model';
import { ISessionLecturerCreateData, ISessionLecturerUpdateData } from 'src/app/shared/models/session-group/session-lecturer-change-data.model';
import { WarningIconComponent, WarningIconStyle } from 'src/app/shared/components/icons/warning-icon/warning-icon.component';
import { RoleType } from 'src/app/shared/enums/user/role-types.enum';
import { PricePipe } from 'src/app/shared/pipes/price.pipe';
import { TypeofPipe } from 'src/app/shared/pipes/typeof.pipe';
import { UtilsService } from 'src/app/shared/services/utils.service';
import { ICallablesSessionsUpdateData } from 'src/app/shared/services/entities/sessions/sessions.service';
import { HourRateModalComponent } from './hour-rate-modal/hour-rate-modal.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { LocalizedDatePipe } from 'src/app/shared/pipes/localized-date.pipe';
import { Chips, ChipsModule } from 'primeng/chips';
import { LecturersPickerModalComponent } from 'src/app/shared/modals/lecturers-picker-modal/lecturers-picker-modal.component';
import { IUser } from 'src/app/shared/models/user/user.model';
import { ILocket } from 'src/app/shared/models/locket/locket.model';
import { IStartAtEndAtFG, StartAtEndAtInputComponent, getStartAtEndAtFG } from './start-at-end-at-input/start-at-end-at-input.component';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputNumberModule } from 'primeng/inputnumber';
import { UserPreferencesStoreService } from 'src/app/shared/services/store/user-preferences-store.service';
import { LocationPickerModalComponent } from '../location-picker-modal/location-picker-modal.component';
import { SelectedOrgService } from 'src/app/shared/services/selected-org.service';
import { SessionAttendancesService } from 'src/app/shared/services/entities/session-attendances/session-attendances.service';
import { PdfService } from 'src/app/shared/services/pdf.service';

export enum SessionCardTab {
  SETTINGS = 0,
  PARTICIPANTS = 1,
}

interface ISessionFG {
  title: FormControl<string | null>;
  dates: FormGroup<IStartAtEndAtFG>;
  format: FormControl<SessionFormat>;
  locationId?: FormControl<number | null>;
  meetingUrl?: FormControl<string | null>;
  // description: FormControl<string>;
  lecturers: FormArray<FormGroup<ISessionLecturerFormGroup>>;
  // lecturerAttendanceClosed: FormControl<boolean>;
  sessionLecturerAttendanceTags: FormControl<string[]>;
  timesCnt: FormControl<number>;
  duration: FormControl<number | null>;
  hourDuration: FormControl<number>;
}

interface ISessionLecturerFormGroup {
  id: FormControl<number | null>;
  lecturerId: FormControl<number>;
  type: FormControl<SessionLecturerType>;
  hourRate: FormGroup<IHourRateFG>;
  state: FormControl<SessionLecturerState | null>;
  warningEnabled: FormControl<boolean>;
}

@Component({
  selector: 'app-session-card-modal',
  standalone: true,
  imports: [
    CommonModule, ReactiveFormsModule, TranslateModule,
    ButtonModule, TabViewModule, SkeletonModule, ProgressSpinnerModule, InputTextModule, SelectButtonModule, CalendarModule, DropdownModule, MenuModule, ChipsModule, InputGroupModule, InputGroupAddonModule, InputNumberModule,
    ModalHeaderComponent, SessionAttendanceComponent, LecturerAvatarNameComponent, SelectButtonColoredComponent, WarningIconComponent, PricePipe, TypeofPipe, StartAtEndAtInputComponent,
    NgbTooltipModule, LocalizedDatePipe,
  ],
  templateUrl: './session-card-modal.component.html',
  styleUrls: ['./session-card-modal.component.scss']
})
export class SessionCardModalComponent extends Modal implements OnInit, OnDestroy {
  SessionLecturerType = SessionLecturerType;
  WarningIconStyle = WarningIconStyle;
  SessionFormat = SessionFormat;
  SessionCardTab = SessionCardTab;

  @Input() sessionUuid: string | undefined;
  
  _activeTab: SessionCardTab = SessionCardTab.SETTINGS;
  get activeTab() { return this._activeTab }
  @Input() set activeTab(val: SessionCardTab | undefined) {
    this._activeTab = val ?? SessionCardTab.SETTINGS;
  }
  @Input() noNeedToFetchLecturers: boolean = false;

  form = new FormGroup<ISessionFG>({
    title: new FormControl<string | null>(null),
    dates: getStartAtEndAtFG(),
    format: new FormControl<SessionFormat>(SessionFormat.ONSITE, { nonNullable: true, validators: [ Validators.required ]}),
    timesCnt: new FormControl<number>(0, { nonNullable: true }),
    duration: new FormControl(null, { nonNullable: true }),
    hourDuration: new FormControl<number>(60, { nonNullable: true }),

    lecturers: new FormArray<FormGroup<ISessionLecturerFormGroup>>([]),

    sessionLecturerAttendanceTags: new FormControl<string[]>([], { nonNullable: true }),
  })

  NEW_LOCATION_OPTION_ID = -42;

  sessionCardData: ISessionCardData | null = null;
  state: ISessionCardState = this.sessionCardStoreService.state;
  lecturersState: ILecturersState = this.lecturersStore.state;
  locationsState: IOrgLocationsState | undefined = this.orgLocationsStore.getState();

  
  formatOptions = [
    { label: `SessionFormat.${SessionFormat.ONSITE}`, value: SessionFormat.ONSITE },
    { label: `SessionFormat.${SessionFormat.ONLINE}`, value: SessionFormat.ONLINE },
  ];
  hourDurationOptions: SelectItem[] = [];
  memberMenuItems: MenuItem[] = [];
  teamMenuItems: MenuItem[] = [];
  memberMenuItemIndex = -1;
  stateOptions: ISelectButtonColoredItem[] = [
    {
      value: SessionLecturerState.PRESENT,
      icon: 'pi pi-check',
      color: Color.SUCCESS,
      tooltip: `SessionLecturerState.${SessionLecturerState.PRESENT}`
    },
    {
      value: SessionLecturerState.ABSENT,
      icon: 'pi pi-times',
      color: Color.DANGER,
      tooltip: `SessionLecturerState.${SessionLecturerState.ABSENT}`
    }
  ];
  timesCntMenuItems: MenuItem[] = [];
  // locationOptions: (ILocation | {id: number, title: string} )[] = [];
  lecturers: ILecturer[] = [];
  updatingLecturers: number[] = [];
  get selectedLocation() { return this.form.controls.locationId?.value === this.sessionCardData?.session.locationId ? this.sessionCardData?.session.location : this.locationsState?.locations$.getValue().find(x => x.id === this.form.controls.locationId?.value)}
  preparingAttendancePdfDownload: boolean = false;

  sessionFormPatched: boolean = false;

  subs: Subscription[] = [];
  locationsSub: Subscription = Subscription.EMPTY;

  constructor(
    private sessionCardStoreService: SessionCardStoreService,
    public siHelper: ShopItemHelperService,
    private modalService: ModalService,
    private lecturersStore: LecturersStoreService,
    private nameOrEmailPipe: UserNameOrEmailPipe,
    private utilsService: UtilsService,
    private modal: NgbModal,
    private translate: TranslateService,
    private userPreferencesStore: UserPreferencesStoreService,
    private orgLocationsStore: OrgLocationsStoreService,
    public selectedOrg: SelectedOrgService,
    private sessionAttendanceService: SessionAttendancesService,
    private pdfService: PdfService,
    private localizedDatePipe: LocalizedDatePipe
  ) {
    super();

    this.subs.push(
      this.translate.onLangChange.subscribe(() => {
        this.createTeamMenuItems();
        this.createMemberMenuItems();
        this.createHourDurationOptions();
      }),

      this.selectedOrg.selectedOrg$.subscribe(() => {
        this.createTimesCntMenuItems();
      })
    );
  }

  override ngOnInit(): void {
    super.ngOnInit();

    if (this.sessionUuid) {
      this.sessionCardStoreService.reset(); // resetting first so the value is null, without this patching would be broken (would load old value if card reopens) due to specific implementation of sessionCardStoreService :)
      this.sessionCardStoreService.init(this.sessionUuid);
      if (!this.noNeedToFetchLecturers) this.lecturersStore.init(); // todo mozna optimalizace - asi neni uplne nutne vzdy fetchovat vsechny lektory znovu a znovu
      this.watchState();
      this.createTeamMenuItems();
      this.createMemberMenuItems();
      this.createHourDurationOptions();

    } else this.close();
  }

  private createMemberMenuItems() {
    this.memberMenuItems = [{
      label: this.translate.instant('admin.attendance.lessons-overview.sessions.session-detail-modal.team.item.remove'),
      icon: 'pi pi-trash',
      command: () => { this.onRemoveSessionLecturer(this.memberMenuItemIndex); this.memberMenuItemIndex = -1; } // dont forget to reset index
    }];
  }

  private createTeamMenuItems() {
    this.teamMenuItems.length = 0;
    this.teamMenuItems = [{
      label: this.translate.instant('admin.attendance.lessons-overview.sessions.session-detail-modal.team.menu-item.add-lecturer'),
      command: () => { this.onAddSessionLecturer(SessionLecturerType.REGULAR) }
    }, {
      label: this.translate.instant('admin.attendance.lessons-overview.sessions.session-detail-modal.team.menu-item.add-sub'),
      command: () => { this.onAddSessionLecturer(SessionLecturerType.SUBSTITUTION) }
    }];
  }

  private onAddSessionLecturer(type: SessionLecturerType) {
    if (!this.sessionCardData?.shopItem.organizationId) return;

    const lecturers$ = new BehaviorSubject<(ILecturer & { user: IUser & { lockets: ILocket[] } })[]>([]);
    this.subs.push(
      this.lecturersState.lecturers$.subscribe(lecturers => {
        const notSelectedLecturers = lecturers.filter(x => !this.form.controls.lecturers.value.find(y => y.lecturerId === x.id));
        lecturers$.next(notSelectedLecturers as any);
      })
    );

    const res = this.modalService.openLecturerPickerModal(LecturersPickerModalComponent, lecturers$ , [], this.sessionCardData?.shopItem.organizationId)
    res.subscribe({
      next: (selectedLecturerIds) => {
        for (let id of selectedLecturerIds) {
          const lecturer = this.lecturers.find(x => x.id === id);
          if (lecturer) this.addLecturer(lecturer, type);
        }
      }
    });
  }

  onSubmit() {
    this.utilsService.markFormGroupDirty(this.form);
    if (this.form.invalid || this.state.updatingSessionData$.getValue() || !this.sessionCardData) {
      console.error('invalid');
      return;
    };

    const formVals = this.form.getRawValue();

    const startAt = timeStringToDate(formVals.dates.startAt!, formVals.dates.startAtTime, true)?.toISOString();
    const endAt = timeStringToDate(formVals.dates.endAt!, formVals.dates.endAtTime, true)?.toISOString();

    const d: ICallablesSessionsUpdateData = {
      id: this.sessionCardData.session.id,
      startAt: startAt!,
      endAt: endAt!,
      format: formVals.format,
      title: formVals.title,
      sessionLecturerAttendanceTags: formVals.sessionLecturerAttendanceTags,
      meetingUrl: formVals.meetingUrl ?? null,
      locationId: formVals.locationId ?? null,
      duration: formVals.timesCnt * formVals.hourDuration,
      hourDuration: formVals.hourDuration
    };

    this.sessionCardStoreService.updateSession(d).pipe(
      take(1),
      
    ).subscribe({
      next: (res) => {
        this.sessionFormPatched = false;
        this.close();
      }
    })
  }


  getLecturerById(id: number) {
    return this.sessionCardData?.session.sessionLecturers?.map(x => x.lecturer).filter(x => x).find(x => x!.id === id) || this.lecturers.find(x => x.id === id);
  }

  private watchState() {
    this.subs.push(
      this.state.sessionData$.pipe(
        filter((x) => x?.session.uuid === this.sessionUuid)
      ).subscribe(d => {
        this.sessionCardData = d;
        if (d) {
          // patch sessionFG only once, when sessionData is fetched
          // if you need to remove this once-only-patch, keep in mind you need to resolve this:
          // when user edits the session FG and does not save it, then for example removes lecturer - this will trigger change on sessionData$
          // and would patch the form again with 'old', unsaved data - removing all user unsaved changes
          this.patchForm(d, this.sessionFormPatched ? false : true);
        }
        if (d?.session.lecturerAttendanceClosed) this.form.controls.lecturers.disable({ emitEvent: false });
        else this.form.controls.lecturers.enable({ emitEvent: false });
      }),

      this.lecturersState.lecturers$.subscribe(lecturers => {
        this.lecturers = lecturers;
      })
    )
  }

  private watchFormat() {
    this.checkFormat(this.form.controls.format.value)
    this.subs.push(
      this.form.controls.format.valueChanges.subscribe(format => {
        this.checkFormat(format);
      })
    )
  }
  private checkFormat(format: SessionFormat) {
    if (format === SessionFormat.ONLINE) {
      this.form.addControl('meetingUrl', new FormControl<string | null>(this.sessionCardData?.session.meetingUrl || null));
      this.form.removeControl('locationId');
    } else {
      this.form.addControl('locationId', new FormControl<number | null>(this.sessionCardData?.session.location?.id || null));
      this.form.removeControl('meetingUrl');
    }
  }

  private watchDates(FG: FormGroup<ISessionFG>) {
    this.subs.push(
      merge(FG.controls.dates.controls.startAt.valueChanges, FG.controls.dates.controls.endAt.valueChanges, FG.controls.dates.controls.startAtTime.valueChanges, FG.controls.dates.controls.endAtTime.valueChanges).subscribe((x) => {
        this.handleNullDurationTimeAllocation();
      })
    );
  }

  private patchForm(sessionData: ISessionCardData, patchSessionForm: boolean) {
    const s = sessionData.session;

    if (patchSessionForm) {
      const startAtUTCDate = new Date(s.startAt).localDateToUTC();
      const endAtUTCDate = new Date(s.endAt).localDateToUTC();
      this.form.patchValue({
        ...s,
        dates: {
          startAt: startAtUTCDate,
          startAtTime: dateToTimeString(startAtUTCDate)!,
          endAt: endAtUTCDate,
          endAtTime: dateToTimeString(endAtUTCDate)!,
        },
        sessionLecturerAttendanceTags: sessionData.shopItem.sessionGroup.sessionLecturerAttendanceTags,
        timesCnt: (s.duration ?? 0) / s.hourDuration,
        duration: s.duration,
        hourDuration: s.hourDuration,
      }, { emitEvent: false });
  
      if (s.duration === null) {
        this.handleNullDurationTimeAllocation();
      }

      this.watchDates(this.form);
      this.watchFormat();

      this.sessionFormPatched = true;
    }

    this.form.controls.lecturers.clear({ emitEvent: false });
    for (let l of sessionData.session.sessionLecturers ?? []) {
      this.addSessionLecturerFG(l);
    }

  }
  addSessionLecturerFG(data: Partial<ISessionLecturer>) {
    const FG = this.getSessionLecturerFG();
    FG.patchValue(<any>data, { emitEvent: false });
    this.form.controls.lecturers.push(FG, { emitEvent: false });
    this.watchSessionLecturerFG(FG);

    return FG;
  }
  getSessionLecturerFG() {
    const FG = new FormGroup<ISessionLecturerFormGroup>({
      id: new FormControl(null),
      lecturerId: new FormControl(-1, { nonNullable: true }),
      type: new FormControl(),
      hourRate: getHourRateFG(),
      state: new FormControl(null),
      warningEnabled: new FormControl(true, { nonNullable: true })
    });
    return FG;
  }
  watchSessionLecturerFG(FG: FormGroup<ISessionLecturerFormGroup>) {
    this.subs.push(
      FG.valueChanges.subscribe(vals => {
        this.handleSessionLecturerFGchange(FG);
      })
    );
  }
  handleSessionLecturerFGchange(FG: FormGroup<ISessionLecturerFormGroup>) {
    if (!this.sessionCardData?.session) return;
    
    const vals = FG.getRawValue();
    if (!vals.id) return;

    const data: ISessionLecturerUpdateData = {
      sessionId: this.sessionCardData.session.id,
      ...vals,
      id: vals.id,
    };

    this.updatingLecturers.push(vals.id);
    this.sessionCardStoreService.updateSessionLecturer(data).pipe(

    ).subscribe({
      next: (res) => {
        this.updatingLecturers = this.updatingLecturers.filter(x => x !== vals.id);
      },
      error: (err) => {
        this.updatingLecturers = this.updatingLecturers.filter(x => x !== vals.id);
      }
    });
  }
  private handleNullDurationTimeAllocation() {
    if (this.form.controls.duration.value === null) {
      const formVals = this.form.getRawValue();
      const startAt = timeStringToDate(formVals.dates.startAt!, formVals.dates.startAtTime, true);
      const endAt = timeStringToDate(formVals.dates.endAt!, formVals.dates.endAtTime, true);
      const hourDuration = this.form.controls.hourDuration.value;
      if (startAt && endAt) {
        const diff = Math.abs(endAt.getTime() - startAt.getTime());
        const timesCnt = diff / 1000 / 60 / hourDuration;
        this.form.controls.timesCnt.setValue(timesCnt, { emitEvent: false });
      }
    }
  }

  onLocationDropdownClick() {
    if (!this.sessionCardData) return;
    const res = this.modalService.openLocationPickerModal(LocationPickerModalComponent, this.form.controls.dates, this.form.controls.locationId!, this.sessionCardData.session, this.sessionCardData.shopItem);
    res.pipe(
      take(1)
    ).subscribe({
      next: (res) => {
        if (res.locationId) {
          this.form.controls.locationId?.setValue(res.locationId, { emitEvent: false });
        }
        this.form.controls.dates.patchValue(res.dates, { emitEvent: true });
      }
    })
  }

  onSessionLecturerWarningEnabledToggle(FC: FormControl<boolean>) {
    FC.setValue(!FC.value);
  }

  onLecturerHourRate(c: FormGroup<ISessionLecturerFormGroup>) {
    const ref = this.modal.open(HourRateModalComponent, {
      size: 'sm',
    });
    ref.componentInstance.ref = ref;
    ref.componentInstance.FG = c.controls.hourRate;
  }

  onHourDurationChange(e: DropdownChangeEvent) {
    this.userPreferencesStore.upsert({
      admin_session_hour_duration: e.value
    })?.subscribe();
  }

  onLocationSelect(e: { originalEvent: Event, value: number }, dropdown: Dropdown, fc: FormControl<number | null>) {
    // dropdown.hide();

    if (!e.value) return;
    if (e.value === this.NEW_LOCATION_OPTION_ID) {
      const res = this.modalService.openLocationModal({
        c: LocationModalComponent,
        operation: Operation.CREATE
      });
      res.pipe(take(1)).subscribe(res => {
        if (res.data) fc.setValue(res.data.id);
      });
      fc.setValue(null)
      return;
    }
    fc.setValue(e.value)
  }


  addLecturer(lecturer: ILecturer, type: SessionLecturerType) {
    if (!this.sessionCardData) return;
    if (!this.form.controls.lecturers.value.find(x => x.lecturerId === lecturer.id)) {
      const FG = this.addSessionLecturerFG({ type, lecturerId: lecturer.id, hourRate: lecturer.user?.roles.find(x => x.type === RoleType.LECTURER)?.hourRate });
      this.watchSessionLecturerFG(FG);

      const formValues = FG.getRawValue();
      const data: ISessionLecturerCreateData = {
        hourRate: formValues.hourRate,
        state: formValues.state,
        type: formValues.type,

        lecturerId: formValues.lecturerId,
        sessionId: this.sessionCardData.session.id
      };
      this.sessionCardStoreService.createSessionLecturer(data).pipe(

      ).subscribe({
        next: (res) => {
          FG.patchValue({ id: res.id }, { emitEvent: false });
        }
      });
    }
  }
  onRemoveSessionLecturer(i: number) {
    const id = this.form.controls.lecturers.controls[i].value.id;

    // lektor byl tedka pridan a tak sessionLecturer nema id, v tomto pripade 
    if (id === null) {

    }
    // this.form.controls.lecturers.removeAt(i);

    if (!id) return;
    this.sessionCardStoreService.deleteSessionLecturer(id).subscribe({
      next: () => {
        // this.form.controls.lecturers.removeAt(i);
      }
    })
  }

  onChipsInputBlur(e: Event, el: Chips) {
    let inputVal = el.inputViewChild.nativeElement.value;
    if (inputVal.length) {
      el.addItem(e, inputVal, false);
      inputVal = '';
    }
  }

  onTimesCntInputClick(e: Event, timesCntMenu: Menu) {
    if (this.selectedOrg.selectedOrg$.value?.sessionTimeDonationWhisperValues.length) {
      timesCntMenu.toggle(e);

      setTimeout(() => {
        (e.target as any)?.focus();
      })
    }
  }


  

  getLecturerConflictTooltip(lecturerSessionDataItem: ISessionCardData | undefined, lecturer: ILecturer | undefined) {
    // Shouldn't happen, but just in case..
    if ((!lecturer || !lecturerSessionDataItem)) {
      return this.translate.instant('admin.attendance.lessons-overview.sessions.session-detail-modal.lecturer-conflict-tooltip.mismatch');
    }
    let tooltip = `${this.nameOrEmailPipe.transform(lecturer?.user?.orgUsers??[], lecturerSessionDataItem.shopItem.organizationId, true)} `;

    if (lecturerSessionDataItem.conflictedLecturers[lecturer.id].lecturingWith.length === 0) {
      tooltip += this.translate.instant(`admin.attendance.lessons-overview.sessions.session-detail-modal.lecturer-conflict-tooltip.alone`);
    } else {
      tooltip += this.translate.instant('admin.attendance.lessons-overview.sessions.session-detail-modal.lecturer-conflict-tooltip.lectured-with');
      tooltip += ' ' + lecturerSessionDataItem.conflictedLecturers[lecturer.id].lecturingWith.map(lecturerId => {
        const foundLecturer = this.getLecturerById(lecturerId);
        return this.nameOrEmailPipe.transform(foundLecturer?.user?.orgUsers??[], lecturerSessionDataItem.shopItem.organizationId, true);
      }).join(', ');
    }
    return tooltip;
  }
  hasConflict(lecturerSessionDataItem: ISessionCardData | undefined, lecturerId: number) {
    if (!lecturerId || !lecturerSessionDataItem) {
      return false;
    }
    if (lecturerId in lecturerSessionDataItem.conflictedLecturers) {
      return true;
    } else {
      return false;
    }
  }

  private createHourDurationOptions() {
    this.hourDurationOptions = [
      {
        value: 45,
        label: this.translate.instant('admin.time-allocation-input.interval-options.45.label')
      },
      {
        value: 60,
        label: this.translate.instant('admin.time-allocation-input.interval-options.60.label')
      }
    ];
  }

  private createTimesCntMenuItems() {
    this.timesCntMenuItems = this.selectedOrg.selectedOrg$.value?.sessionTimeDonationWhisperValues.map(v => ({
      label: v.toString(),
      command: () => {
        this.form.controls.timesCnt.setValue(v);
      }
    })) ?? [];
  }

  async onDownloadAttendancePdf() {
    if (!this.sessionCardData) return;

    this.preparingAttendancePdfDownload = true;
    downloadSessionAttendancePdf(
      this.pdfService,
      this.sessionAttendanceService,
      this.sessionCardData.session.id,
      {
        shopItemTitle: this.sessionCardData.shopItem.title,
        sessionIndex: this.sessionCardData.session.index,
        startAt: this.sessionCardData.session.startAt,
      },
      this.translate,
      this.localizedDatePipe,
    ).pipe(
      take(1)
    ).subscribe({
      next: () => {
        this.preparingAttendancePdfDownload = false;
      },
      error: (err) => {
        this.preparingAttendancePdfDownload = false;
        console.error('Error downloading session attendance PDF:', err);
      }
    });
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();
    
    this.subs.forEach((sub) => sub.unsubscribe());
    this.locationsSub.unsubscribe();
  }
}


export function downloadSessionAttendancePdf(
  pdfService: PdfService,
  sessionAttendanceService: SessionAttendancesService,
  sessionId: number,
  fileName: {
    shopItemTitle: string,
    sessionIndex: number,
    startAt: string,
  },
  translate: TranslateService,
  localizedDatePipe: LocalizedDatePipe,
) {
  return sessionAttendanceService.getPdf({
      sessionId: sessionId
    }).pipe(
      take(1),
      map(async res => {
        await pdfService.downloadPdf(await pdfService.base64PdfToArrayBuffer(res), translate.instant('admin.attendance.lessons-overview.sessions.session-detail-modal.attendance-document-name', {
          shopItemTitle: fileName.shopItemTitle,
          sessionIndex: fileName.sessionIndex + 1,
          startAt: localizedDatePipe.transform(fileName.startAt, 'shortDate', undefined, 'UTC+0'),
        }))
      })
    );
}